import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

// components
import VendorInvoiceList from "./VendorInvoiceList";
import Loading from "../../components/Loading";
// global
import {
  projectStore,
  userStore,
} from "../../store/Store";
// hooks
import useGetFetch from "../../hooks/useGetFetch";
// css and images
import Upload from "../../assets/upload.svg";
import Add from "../../assets/add.svg"

import { a11yProps, CustomTabPanel } from "../../components/TabPanels";


export default function VendorInvoiceTabs({
  setTriggerFreightInvoice,
  setTriggerSandInvoice,
  setTriggerAssetInvoice,
  setTriggerGenerateFreight,
  setTriggerGenerateAsset,
  invoiceType,
  setInvoiceType,
}) {
  // global
  const projectVendorInvoices = projectStore(
    (data) => data.projectVendorInvoices
  );
  const setProjectVendorInvoices = projectStore(
    (data) => data.setProjectVendorInvoices
  );
  const currentProject = projectStore((data) => data.currentProject);
  const JwtToken = userStore((data) => data.JwtToken);
  const currentUser = userStore((data) => data.currentUser);
  const setAuthStatus = userStore((data) => data.setAuthStatus);

  // local
  const navigate = useNavigate();
  const [value, setValue] = useState(0);
  const [containsSand, setContainsSand] = useState(false);
  const [containsFreight, setContainsFreight] = useState(false);
  const [containsAsset, setContainsAsset] = useState(false);

  const handleChange = (_, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      setInvoiceType("Freight");
    } else if (newValue === 1) {
      setInvoiceType("Sand");
    } else {
      setInvoiceType("Asset");
    }
  };
  const { pending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/vendor-invoices/${currentProject.project.id}`,
    setProjectVendorInvoices
  );
  const DownloadTemplate = () => {
    var endpoint;
    if (invoiceType !== "Sand") {
      endpoint = "vendor-invoice-template.csv";
    } else {
      endpoint = "sand-invoice-template.csv";
    }
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + JwtToken);
    headers.append("Content-Type", "text/csv");
    const requestOptions = {
      method: "GET",
      headers,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/lc/get-file/${endpoint}/templates/csv&user_id=${currentUser.id}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 401) {
          setAuthStatus(false);
          navigate("/");
        }
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = url;
        alink.download = `${endpoint}`;
        alink.click();
      });
  };
  // determine if there are sand and vendor invoices
  useEffect(() => {
    if (projectVendorInvoices && projectVendorInvoices.invoices) {
      const sandExists = projectVendorInvoices.invoices.filter(
        (x) => x.is_sand
      );
      const freightExists = projectVendorInvoices.invoices.filter(
        (x) => !x.is_asset && !x.is_sand
      );
      const assetsExist = projectVendorInvoices.invoices.filter(
        (x) => x.is_asset
      );
      if (sandExists.length > 0) {
        setContainsSand(true);
      }
      if (freightExists.length > 0) {
        setContainsFreight(true);
      }
      if (assetsExist.length > 0) {
        setContainsAsset(true);
      }
    }
  }, [
    projectVendorInvoices,
    setContainsSand,
    setContainsAsset,
    setContainsFreight,
  ]);

  const handleTrigger = () => {
    if (invoiceType === "Freight") {
      setTriggerFreightInvoice(true);
    } else if (invoiceType === "Sand") {
      setTriggerSandInvoice(true);
    } else if (invoiceType === "Asset") {
      setTriggerAssetInvoice(true);
    }
  };

  const handleAdd = () => {
    if (value === 0) {
      setTriggerGenerateFreight(true)
    } else if (value === 2) {
      setTriggerGenerateAsset(true)
    }
  }

  if (error) {
    return <p className="error">{error}</p>;
  } else if (pending) {
    return <Loading />;
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          margin: "20px 0 0 0",
        }}
      >
        <div className="d-flex justify-content-between">
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Freight Invoices"
                {...a11yProps(2)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
              <Tab
                label="Sand Invoices"
                {...a11yProps(1)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
              <Tab
                label="Asset Invoices"
                {...a11yProps(0)}
                sx={{
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              />
            </Tabs>
          </Box>
          <div>
            <button
              className="btn btn-secondary panel-button"
              onClick={DownloadTemplate}
            >
              Download {invoiceType}
              Template
            </button>
            {!currentProject.project.archived && (
              <img
                src={Upload}
                alt="upload"
                onClick={handleTrigger}
                className="project-delete-image"
              />
            )}
            {(!currentProject.project.archived && (value === 0 || value === 2)) && 
              <img
                src={Add}
                alt="add_invoice"
                onClick={handleAdd}
                className="project-delete-image"
              />
            }
          </div>
        </div>
        <CustomTabPanel value={value} index={0}>
          {containsFreight ? (
            <VendorInvoiceList invoiceType={"Freight"} />
          ) : (
            <div>No Freight Invoices Have been added.</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {containsSand ? (
            <VendorInvoiceList invoiceType={"Sand"} />
          ) : (
            <div>No Sand Invoices Have been added.</div>
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {containsAsset ? (
            <VendorInvoiceList invoiceType={"Asset"} />
          ) : (
            <div>No Asset Invoices Have been added.</div>
          )}
        </CustomTabPanel>
      </Box>
    );
  }
}
